var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ds-modal", {
    attrs: { open: _vm.open },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "modal-dialog go-modal-connect" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "modal-title" }, [
                    _vm._v(
                      _vm._s(_vm.channelConnect.channelName) +
                        " " +
                        _vm._s(_vm.$t("scrap-agent.register-table.account"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon close",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: { click: _vm.handleCloseModal },
                    },
                    [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "go-form-connect-account" }, [
                    _c("div", { staticClass: "go-form-header" }, [
                      _c("div", { staticClass: "go-brand" }, [
                        _c("div", { staticClass: "go-brand-symbol" }, [
                          _c("img", {
                            attrs: {
                              src:
                                _vm.channelConnect.channelImageUri ||
                                "https://blogpfthumb-phinf.pstatic.net/MjAxOTA2MThfMjE2/MDAxNTYwODM2ODQ5MDk5.QteT5YL-OesHK0KxOdLg_5sTkIOvAqT10uVjT8rdNrsg.IIvp-gexFczdgl3bbJL4riqyDoTLAJkXOSSbfJEB6JUg.PNG.blogpeople/%255BTeamBlog%255DProfile%25402x.png?type=s1",
                              alt: "logo",
                            },
                          }),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "go-form-body" },
                      [
                        _c(
                          "vue-custom-scrollbar",
                          {
                            staticClass:
                              "go-list-inner overflow-y-scroll customScroll csScrollPosition listWrapBoxMyReport",
                            attrs: { settings: _vm.scrollSettings },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "account-select" },
                              [
                                _vm._l(
                                  _vm.channelConnect.accounts,
                                  function (item, index) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass:
                                            "d-flex flex-row justify-content-between align-items-center p-2 border",
                                          staticStyle: {
                                            position: "relative",
                                            "border-radius": "0.5rem",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center select-item",
                                              class: _vm.getAccountClass(item),
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.handleSubmitAccount(
                                                    _vm.channelConnect,
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass: "go-user-thumb",
                                                  staticStyle: {
                                                    "min-width": "40px",
                                                    "margin-right": "10px",
                                                  },
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: item.avatar,
                                                      alt: "avatar",
                                                    },
                                                    on: {
                                                      error: function ($event) {
                                                        return _vm.onImageError(
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "account-name" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.truncateAccountName(
                                                        item.accountName,
                                                        item.fullName
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.highLightAccount &&
                                              item.accountId ===
                                                _vm.highLightAccount
                                                ? _c(
                                                    "span",
                                                    { staticClass: "badge" },
                                                    [
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(
                                                            index === 0
                                                              ? _vm.$t(
                                                                  _vm.highLightAcc(
                                                                    index,
                                                                    item.accountId
                                                                  )
                                                                )
                                                              : _vm.$t(
                                                                  "scrap-agent.account.update"
                                                                )
                                                          ) +
                                                          "\n                        "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.isExpiredAccount(item)
                                                ? _c(
                                                    "span",
                                                    { staticClass: "badge" },
                                                    [_vm._v(" Expired! ")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "btn-group" },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn go-btn-secondary go-btn-icon mb-0",
                                                  staticStyle: {
                                                    border: "none",
                                                    "background-color":
                                                      "transparent",
                                                  },
                                                  attrs: {
                                                    type: "button",
                                                    "data-toggle": "dropdown",
                                                    "aria-pressed": "false",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "go-icon-18 go-icon-more-dot",
                                                    staticStyle: {
                                                      width: "24px",
                                                      height: "24px",
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "dropdown-menu dropdown-menu-right",
                                                  class: {
                                                    "dropdown-menu-end":
                                                      index ===
                                                      _vm.channelConnect
                                                        .accounts.length -
                                                        1,
                                                  },
                                                  staticStyle: { left: "-2px" },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-item-wrap",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "dropdown-item",
                                                          staticStyle: {
                                                            border: "none",
                                                            padding: "5px 14px",
                                                            "justify-content":
                                                              "flex-start",
                                                          },
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.handleUpdateAccount(
                                                                item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "go-icon-16 go-icon-user-setting",
                                                          }),
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "scrap-agent.account.re-au"
                                                              )
                                                            ) +
                                                              "\n                            "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "dropdown-item",
                                                          staticStyle: {
                                                            border: "none",
                                                            padding: "5px 14px",
                                                            "justify-content":
                                                              "flex-start",
                                                          },
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.handleDeleteAccount(
                                                                item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "go-icon-16 go-icon-trash",
                                                          }),
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "scrap-agent.account.delete"
                                                              )
                                                            ) +
                                                              "\n                            "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  }
                                ),
                              ],
                              2
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm.channelConnect.channelType !== "YOUTUBE"
                  ? _c(
                      "div",
                      { staticClass: "modal-footer justify-content-between" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn go-btn-default",
                            attrs: { type: "button", "data-dismiss": "modal" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.handleCloseModal.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("scrap-agent.back")) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn go-btn-default",
                            staticStyle: { width: "220px", height: "38px" },
                            attrs: { type: "button", "data-dismiss": "modal" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.handleShowAddAccount.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "go-icon-16 go-icon-plus" }),
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "scrap-agent.register-table.register-another-account"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.channelConnect.channelType == "YOUTUBE"
                  ? _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn go-btn-default",
                          attrs: { type: "button", "data-dismiss": "modal" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.$emit("modal:close")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("scrap-agent.back")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn go-btn-primary",
                          staticStyle: {
                            "white-space": "nowrap",
                            "min-width": "130px",
                          },
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.handleShowAddAccount.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "scrap-agent.register-table.register-account-yt"
                                )
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }